import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import { getToken } from '@/utils/authorized'

import Antd from "ant-design-vue";
import { message,notification } from "ant-design-vue";

message.config({
  top: `50%`,
  duration: 2,
  maxCount: 3,
});

notification.config({
  placement: 'bottomRight',
  bottom: '50px',
  duration: 3,
});

import "ant-design-vue/dist/antd.less";
import footerView from "./views/footer.vue";
import calculatorView from "./components/calculator.vue";

import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

window.notification = notification;
window.message = message;
window.router = router;

Vue.config.productionTip = false;
if (process.env.NODE_ENV == 'production') {
  // window._console = window.console
  // window._error = window.error
  // window.console = window.error = {
  //   log: function() {},
  //   error: function() {}
  // }
}

Vue.config.productionTip = false;
const track = function(event,obj) {  //event-事件名，obj数据
  sensors.track(event, {
    ...obj
  });
}
Vue.prototype.track = track

Vue.use(Antd);
Vue.component("footer-view", footerView);
Vue.component("calculator-view", calculatorView);
const auth = {
  loggedIn: () => {
    return getToken();
  }
};

router.beforeEach((to, from, next) => {
  console.log("beforeEach -> ", to, from);
  if (to.name == 'login' && auth.loggedIn()) {
    next({
      name: 'home'
    })
    return
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!auth.loggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
